import { theme } from "kosmos-ui/lib";
import styled from "styled-components";

type TProductPriceSpanProps = {
  isOriginalPrice: boolean;
  discountPrice?: number;
};

export const ProductContainer = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorsPalette.black.darker};
  color: white;
  min-height: 100vh;
  padding: 0 72px;

  @media (max-width: 600px) {
    padding: 24px;
  }
`;

export const ProductContentContainer = styled.div<{ headerHeight: number }>`
  display: flex;
  margin: 0 auto;
  max-width: 1200px;
  margin-top: ${({ headerHeight }) => `calc(${headerHeight}px + 72px)`};
  margin-bottom: 72px;
  width: 100%;

  @media (max-width: 600px) {
    margin-bottom: 32px;
    flex-direction: column;
  }
`;

export const ProductImgsThumbContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  overflow-y: scroll;
`;

export const ProductImgThumbContainer = styled.div`
  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const ProductImgThumb = styled.img`
  height: 120px;
  width: 88px;
  cursor: pointer;
  border-radius: 5px;
  object-fit: cover;
`;

export const ProductImgContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-left: 40px;
  border-radius: 8px;
  box-shadow: 2px 4px 18px rgb(0 0 0 / 2%);

  @media (max-width: 600px) {
    margin-bottom: 24px;
    margin-left: 0px;
  }
`;

export const ProductImg = styled.img`
  height: 500px;
  width: 400px;
  cursor: pointer;
  border-radius: 8px;
  object-fit: cover;

  @media (max-width: 600px) {
    height: 100%;
    width: 100%;
  }
`;

export const ProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 72px;
  width: 480px;

  @media (max-width: 600px) {
    width: 100%;
    margin-left: 0px;
  }
`;

export const ProductNameContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const ProductPriceContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ProductPrice = styled.span<TProductPriceSpanProps>`
  font-weight: ${({ theme, isOriginalPrice }) =>
    theme.fontWeights[isOriginalPrice ? "bold" : "regular"]};
  text-decoration: ${({ discountPrice, isOriginalPrice }) =>
    discountPrice && isOriginalPrice ? "line-through" : "none"};
  margin-left: ${({ isOriginalPrice }) => (isOriginalPrice ? "0" : "8px")};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  margin: 24px 0;
  align-items: center;
`;

export const productVariantSelectStyles = {
  //@ts-ignore
  control(base) {
    return {
      ...base,
      border: "none",
      borderRadius: "0",
      boxShadow: "none",
      backgroundColor: "transparent",
      "&:hover": {
        border: "none",
        boxShadow: "none",
      },
      "&:focus": { border: "none", boxShadow: "none" },
      "&:active": { border: "none", boxShadow: "none" },
    };
  },
  //@ts-ignore
  container(base) {
    return {
      ...base,
      border: "none",
      borderBottom: "1px solid #999",
      marginBottom: "24px",
      "&:hover": {
        borderBottom: "1px solid black",
      },
    };
  },
  //@ts-ignore
  valueContainer(base) {
    return { ...base, padding: "8px 0" };
  },
  //@ts-ignore
  dropdownIndicator(base) {
    return {
      ...base,
    };
  },
  //@ts-ignore
  menuList(base) {
    return {
      ...base,
      color: "black",
    };
  },
  //@ts-ignore
  menu(base) {
    return {
      ...base,
      backgroundColor: "white",
    };
  },
  indicatorSeparator() {
    return { display: "none" };
  },
  //@ts-ignore
  singleValue(base) {
    return {
      ...base,
      marginLeft: "0",
      color: "#808080",
      fontSize: theme.fontSizes.regular,
    };
  },
  //@ts-ignore
  placeholder(base) {
    return {
      ...base,
      marginLeft: "0",
      color: "#808080",
      fontSize: theme.fontSizes.regular,
    };
  },
};
